var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavIconHowTo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav-icon-how-to",
    transform: "translate(-140 -465)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5671",
    "data-name": "Rectangle 5671",
    width: 34,
    height: 34,
    transform: "translate(140 465)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6982",
    "data-name": "Group 6982",
    transform: "translate(113.965 -74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108",
    transform: "translate(-3232.32 -413.688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M222.829,140.589a1.2,1.2,0,0,1-1.161-1.562,5.051,5.051,0,1,1,7.069,6.088,1.9,1.9,0,0,0-1.065,1.7,1.2,1.2,0,0,1-1.2,1.2h0a1.2,1.2,0,0,1-1.2-1.2,4.3,4.3,0,0,1,2.389-3.849,2.654,2.654,0,0,0,1.455-2.491,2.765,2.765,0,0,0-2.515-2.516,2.651,2.651,0,0,0-2.632,1.79A1.216,1.216,0,0,1,222.829,140.589Z",
    transform: "translate(3048.487 825.264)",
    fill: "none",
    stroke: "#d1cedc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M311.166,491.017a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,311.166,491.017Z",
    transform: "translate(2964.992 485.87)",
    fill: "none",
    stroke: "#d1cedc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M27.029,13.333A13.7,13.7,0,0,0,15.861,34.957h0l-1.245,4.485L19.1,38.2h0a13.7,13.7,0,1,0,7.928-24.864Z",
    transform: "translate(3248.021 942.355)",
    fill: "none",
    stroke: "#d1cedc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconHowTo);
export default __webpack_public_path__ + "static/media/nav-icon-how-to.75c56ce2da1018da6904dd75c29a82d0.svg";
export { ForwardRef as ReactComponent };